// extracted by mini-css-extract-plugin
export default {"sectionContainer":"styles_sectionContainer__A5FtN","containerOfActivities":"styles_containerOfActivities__Jge12"};